import { Localization } from "@viamap/viamap2-common";
import { getPLAValueTypePostfix, isPLANumberValueType, PLAAttributeDefinition, PLAValueType } from "./PLAState";

function getPLALocale(): string | undefined {
   try {
      return Localization.getLocale();
   } catch {
      return undefined;
   }
}

export function formatPLANumber(value: number): string {
   return new Intl.NumberFormat(getPLALocale()).format(value);
}

export function formatPLANumberWithValueType(value: number, valueType: PLAValueType | undefined): string {
   return `${formatPLANumber(value)}${getPLAValueTypePostfix(valueType)}`;
}

export function formatPLAAttributeValue(value: any, definition: PLAAttributeDefinition | undefined): string {
   if (value === undefined || value === null || value === "") return "";
   if (isPLANumberValueType(definition?.valueType)) {
      const numericValue = typeof value === "number" ? value : Number(value);
      return Number.isFinite(numericValue) ? formatPLANumberWithValueType(numericValue, definition?.valueType) : String(value);
   }
   return String(value);
}